import React, { createContext, useState } from "react";

import { ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material";
import muiTheme from "config/theme/theme";
import palettes from "config/theme/palettes";
import { useCookies } from "react-cookie";


export const ThemeSwitcherContext = createContext();

export const THEMES = {
  primary: "primary",
  info: "info",
  secondary: "secondary",
};

function ThemeSwitcherContextProvider({ children }) {
  const [cookies] = useCookies();

  const defaultTheme = cookies?.["sana-theme"] || THEMES.primary;
  const [theme, setTheme] = useState(defaultTheme);
  const mergedTheme = createTheme({ ...muiTheme, palette: palettes[theme], mode: theme });

  return (
    <ThemeSwitcherContext.Provider value={{ theme, setTheme }}>
      <ThemeProvider theme={mergedTheme}>{children}</ThemeProvider>
    </ThemeSwitcherContext.Provider>
  );
}

export default ThemeSwitcherContextProvider;
